import React from "react";
import { getCalendarTruncationMessage } from "../../utils/calendarPagedFetch";

const CalendarTruncationNotice = ({ data }) => {
  const message = getCalendarTruncationMessage(data);
  if (!message) return null;
  return (
    <output className="mb-3 block rounded-md bg-yellow-50 px-3 py-2 text-xs text-yellow-800 ring-1 ring-yellow-200">
      {message}
    </output>
  );
};

export default CalendarTruncationNotice;
